import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';

const API_BASE = process.env.REACT_APP_API_BASE || '';

// 品牌色：先套用「上次快取的顏色」（避免進站先閃預設紫、載入後才跳成主色），
// 再讀後台主題色覆蓋並更新快取。回訪者不會看到跳色。
const cachedPrimary = localStorage.getItem('brand_primary') || '#222957';
const cachedSecondary = localStorage.getItem('brand_secondary') || '#949DD6';
document.documentElement.style.setProperty('--brand-primary', cachedPrimary);
document.documentElement.style.setProperty('--brand-secondary', cachedSecondary);
(async () => {
  try {
    const res = await fetch(`${API_BASE}/api/settings/theme`);
    if (!res.ok) return;
    const t = await res.json();
    if (t && t.primary) {
      document.documentElement.style.setProperty('--brand-primary', t.primary);
      localStorage.setItem('brand_primary', t.primary);
    }
    if (t && t.secondary) {
      document.documentElement.style.setProperty('--brand-secondary', t.secondary);
      localStorage.setItem('brand_secondary', t.secondary);
    }
  } catch { /* 保持快取/預設色 */ }
})();

// 從後端讀取可即時調整的站台設定（頁標題 / favicon）
(async () => {
  try {
    const res = await fetch(`${API_BASE}/api/settings/site`);
    if (!res.ok) return;
    const data = await res.json();
    if (data && data.title) {
      document.title = data.title;
    }
    if (data && data.favicon) {
      // 更新所有 rel=icon（index.html 可能有多個），避免只改到第一個、其他仍蓋過去
      const links = document.head.querySelectorAll('link[rel~="icon"]');
      if (links.length) {
        links.forEach((l) => { l.removeAttribute('type'); l.href = data.favicon; });
      } else {
        const l = document.createElement('link');
        l.rel = 'icon';
        l.href = data.favicon;
        document.head.appendChild(l);
      }
    }
    // Google Analytics（後台填了 GA 評估 ID 才注入 gtag）
    if (data && data.ga_id && /^G-/.test(data.ga_id)) {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${data.ga_id}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', data.ga_id);
    }
  } catch {
    // 忽略失敗，維持既有 index.html 的預設標題／圖示（星河耀眼）
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
